import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

const ScrollProgress = () => {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, { stiffness: 100, damping: 30, restDelta: 0.001 });
    return (
        <motion.div
            data-testid="scroll-progress"
            style={{ scaleX, transformOrigin: "0% 50%" }}
            className="fixed top-0 left-0 right-0 h-[2px] bg-bisleri z-[60] origin-left"
        />
    );
};

export default ScrollProgress;
